import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import MarketplaceSupplierResource from './MarketplaceSupplierResource';

export default class MarketplaceSuppliersResource extends BaseResource {
  constructor() {
    super({ url: '/api/suppliers' });
  }

  list({ size = 15, includes = '', search = '', offset = 0 } = {}) {
    const params = { size, includes, offset, search };
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(data) {
    return super
      .post(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  supplier(id) {
    return new MarketplaceSupplierResource(`${this.url}/${id}`);
  }
}
